<script>
import otherSearch from "@/views/count/other/otherSearch.vue";
export default {
    name: "DailyOther",
    components:{
        otherSearch
    },
    data() {
        return {
            tableData: [],
            jcxmList:[],
            tableTitle:'温度报表',
            czList:[],
            dataDate: '',
            currentDate: '',
            columns: [
                { label: '水库代码', prop: 'rescd',align:"center"},
                { label: '水库名称', prop: 'resName',align:"center" },
                { label: '日期', prop: 'dt',align:"center" },
                { label: '平均温度(℃)', prop: 'avWt',align:"right" },
                { label: '最高温度(℃)', prop: 'mxWt',align:"right" },
                { label: '最高温度时间', prop: 'mxMstm',align:"right" },
                { label: '最低温度(℃)', prop: 'mnWt',align:"right" },
                { label: '最低温度时间', prop: 'mnMstm',align:"right" },
            ],
        }
    },
    watch:{
        "$store.state.head.skCd"() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.query();
        },
        tableRowClassName({row, rowIndex}) {
            return {
                Color:'white',
                height: '3vh',
            };
        },
        query() {
            const fastChoose = this.$store.state.search.fastChoose;
            const dateValue = this.$store.state.search.dateValue;
            const params = {
                queryDateType: "",
                dtGT: "",
                dtLE: "",
            };
            if (fastChoose !== "ZDY") {
                params.queryDateType = fastChoose;
            } else {
                params.dtGT = dateValue[0];
                params.dtLE = dateValue[1];
            }
            
            
            this.request.get('/rm-report-other/v1/wdj/report',{params:params}).then(
                (res) => {
                    if (res.ok) {
                        if(fastChoose ==='TODAY'||fastChoose ==='YESTERDAY'){
                            this.tableTitle = res.data.dtstrGE+' '+'温度报表';
                        }else{
                            this.tableTitle = res.data.dtstrGE+'至'+res.data.dtstrLE+' '+'温度报表';
                        }
                        this.tableData = res.data.list;
                    } else {
                        this.$message({
                            message: res.error.message,
                            type: 'error',
                            duration: 3000, //显示时间 <=0：永久显示,1000：1s
                        });
                    }
                }
            );
        },
        download() {
            const fastChoose = this.$store.state.search.fastChoose;
            const dateValue = this.$store.state.search.dateValue;
            const params = {
                queryDateType: "",
                dtGT: "",
                dtLE: "",
            };
            if (fastChoose !== "ZDY") {
                params.queryDateType = fastChoose;
            } else {
                params.dtGT = dateValue[0];
                params.dtLE = dateValue[1];
            }
            this.request.get('/rm-report-other/v1/wdj/export',{ params: params,responseType: "blob" }).then((res) => {
                try {
                    let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const a = document.createElement("a");
                    a.href = URL.createObjectURL(blob);
                    // 这里填保存成的文件名
                    a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                    a.click();
                    URL.revokeObjectURL(a.href);
                    return;
                } catch (error) {
                    const reader = new FileReader();
                    reader.readAsText(res.data, 'utf-8');
                    let _this = this;
                    reader.onload=function(){
                        const msg = JSON.parse(reader.result);
                        if (!msg.ok) {
                        if (msg.error.code === 3001) {
                            _this.$message.error(msg.error.message);
                        } else {
                            _this.$message.warning(msg.error.message);
                        }
                        }
                    }
                }
            });
        },
    },
}
</script>

<template>
    <el-container style="padding: 10px 0;">
        <el-header style="position: relative;height: 30px;">
            <otherSearch  
                @query="query"
                @download="download"
                :show-export="true"
            >
            </otherSearch>
        </el-header>
        <el-main style="height: 100%;color: whitesmoke">
            <el-table
                :data="tableData"
                style="width: 100%;padding: 10px"
                border
                height="calc(100vh - 185px)"
                max-height="calc(100vh  - 175px)"
                :row-style="tableRowClassName"
                :header-cell-style="{backgroundColor:'white',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                                fontFamily:'PingFang SC',fontWeight:'bold',fontStretch:'normal',height:'3vh'}"
            >
                <el-table-column label="温度报表" align="center">
                    <template #header>
                        <label style="font-size: 28px">{{tableTitle}}</label>
                    </template>
                    <el-table-column
                        v-for="item in columns"
                        :label="item.label"
                        :width="item.width"
                        :prop="item.prop"
                        :key="item.prop"
                        :align="item.align"
                        header-align="center">
                    </el-table-column>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>

<style scoped>
    ::v-deep .el-main {
        display: block;
        flex: 1;
        flex-basis: auto;
        overflow: auto;
        box-sizing: border-box;
        padding: 0px;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    /* 自定义滚动条样式 */
    ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
        width: 2px; /* 滚动条宽度 */
        height: 1px; /* 滚动条高度 */
    }

    /* 滚动条轨道 */
    ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
        background-color: #f5f5f5; /* 轨道颜色 */
    }

    /* 滚动条滑块 */
    ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #ccc; /* 滑块颜色 */
        border-radius: 2px; /* 滑块圆角 */
    }
</style>
